// VOORBEELDDATA (<Voorbeeld />): de propositie waar de meegebakken
// voorbeelddata van het Plan over gaat (e17.ts, data19.ts, voorbeeld-h23.ts,
// plan/editie11-inhoud.ts). Alleen voor de tests, de proefpagina en het
// contract (contract.ts bouwt de fixtures uit die data). Het echte scherm
// opent op de propositie van de gebruiker (propositie.ts) en leest de inhoud
// van de server (inhoud-server.ts).

import type { PlanPropositie } from "./propositie";

export const VOORBEELD_PROPOSITIE: PlanPropositie = {
  propositie: "ict",
  sector: "ict",
  naam: "ICT",
  regio: "de Brainportregio",
  jaar: 2026,
  fundingSectoren: ["ict"],
  voorbeeld: true,
};

/** De woorden van de voorbeeldteksten, letterlijk zoals ze vóór de pilot stonden. */
export const VOORBEELD_WOORDEN = {
  naam: "ICT",
  werk: "ICT-werk",
  hetWerk: "het ICT-werk",
  regio: "de Brainportregio",
  trends: "ICT-trends",
} as const;
